import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DateIcon } from "../assets/fi-rr-calendar.svg";
import { DatePicker } from "@mantine/dates";

const CustomDOBPicker = ({
  value,
  onChange,
  error = null,
  required = true,
  placeholder = "Enter Date of Birth",
  inputRequired = false,
  inputClassName = "",
  minDate,
  maxDate,
  disabled = false,
}) => {
  const [dateOfBirth, setDateOfBirth] = useState("");

  useEffect(() => {
    const formatDOB = (val) => {
      const parts = val?.split?.("-");
      const [month, day, year] = parts || [];
      console.log(month, day, year);
      return day && month && year ? `${month}-${day}-${year}` : val;
    };

    setDateOfBirth(value);
  }, [value]);

  if (inputRequired) {
    return (
      <DateInput
        placeholder={placeholder}
        value={dateOfBirth}
        required={required}
        onChange={onChange}
        inputClassName={inputClassName}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />
    );
  }

  return (
    <div className="custom-dob-picker">
      <label>
        Date of Birth{" "}
        {required && (
          <span
            style={{
              color: "#D04244",
            }}
          >
            *
          </span>
        )}
      </label>
      <div
        className="input-box"
        style={{
          position: "relative",
        }}
      >
        <DateInput
          placeholder={placeholder}
          value={dateOfBirth}
          required={required}
          onChange={onChange}
          inputClassName={inputClassName}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
        />
      </div>
      {error && <p style={{ color: "red", marginTop: "5px" }}>{error}</p>}
    </div>
  );
};

export default CustomDOBPicker;

function DateInput({
  placeholder,
  value,
  required,
  onChange,
  inputClassName,
  minDate,
  maxDate,
  disabled,
}) {
  const [isOpen, setIsOpen] = useState();
  const dateRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDobChange = (e) => {
    let cleaned = e.target.value.replace(/\D/g, "");
    cleaned = cleaned.slice(0, 8);

    if (cleaned.length > 4) {
      cleaned = cleaned.replace(/^(\d{2})(\d{2})(\d{0,4})/, "$1-$2-$3");
    } else if (cleaned.length > 2) {
      cleaned = cleaned.replace(/^(\d{2})(\d{0,2})/, "$1-$2");
    }

    const parts = cleaned.split("-");
    if (parts.length > 0) {
      let mm = parts[0];
      if (mm && parseInt(mm, 10) > 12) {
        mm = "12";
        cleaned =
          "12" +
          (parts[1] ? "-" + parts[1] : "") +
          (parts[2] ? "-" + parts[2] : "");
      }
    }
    if (parts.length > 2) {
      let yyyy = parts[2];
      const currentYear = new Date().getFullYear();
      if (yyyy && parseInt(yyyy, 10) > currentYear) {
        yyyy = String(currentYear);
        cleaned = parts[0] + "-" + parts[1] + "-" + yyyy;
      } else if (yyyy && String(yyyy).length === 4 && parseInt(yyyy, 10) < 1920) {
        cleaned = parts[0] + "-" + parts[1] + "-" + 1920;
      }
    }
    if (parts.length > 1) {
      let dd = parts[1];
      if (dd && parseInt(dd, 10) > 31) {
        dd = "31";
        cleaned = parts[0] + "-31" + (parts[2] ? "-" + parts[2] : "");
      }
    }
    onChange(cleaned);
  };

  return (
    <>
      <input
        type="tel"
        placeholder={placeholder}
        value={value}
        className={inputClassName || "save-progress-input"}
        onFocus={(e) => {
          if (!value) {
            e.target.placeholder = "mm-dd-yyyy";
          }
        }}
        onBlur={(e) => {
          if (!value) {
            e.target.placeholder = placeholder;
          }
        }}
        onChange={handleDobChange}
        required={required}
        disabled={disabled}
      />
      <DateIcon
        style={{ cursor: "pointer" }}
        onClick={() => {
          if (!disabled) {
            setIsOpen(true);
          }
        }}
      />
      {isOpen && (
        <div
          ref={dateRef}
          className={`date-wrapper`}
          style={{
            padding: "20px",
          }}
        >
          <DatePicker
            // defaultValue={new Date()}
            size="sm"
            value={value}
            onChange={(date) => {
              console.log(date)
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const day = String(date.getDate()).padStart(2, "0");
              const formattedDate = `${month}-${day}-${year}`;
              onChange(formattedDate);
              setIsOpen(false);
            }}
            minDate={minDate}
            maxDate={maxDate}
            defaultDate={value ? new Date(value) : new Date()} 
          />
        </div>
      )}
    </>
  );
}
